import sofiaLogo from "../assets/sofia_logo.webp";
import eosLogo from "../assets/eos_logo.png";
import "./HeaderBar.css";

function HeaderBar() {
  return (
    <header className="top-bar">
      <div className="logo">
        <div className="logo-wrapper">
          <div className="logo-circle">
            <img src={sofiaLogo} alt="Sofia" className="logo-inner-img" />
          </div>
        </div>

        <div className="logo-text-stack">
          <div className="logo-text">Sofia Agent AI</div>
          <div className="logo-subtext">
            powered by
            <span className="powered-by-eos">
              <img src={eosLogo} alt="EOS" className="powered-eos-logo" />
            </span>
          </div>
        </div>
      </div>

      <div className="right-brand" title="Kollecto Plus">
        <span className="right-brand-text">
          KOLLECTO <span className="right-brand-plus">PLUS</span>
        </span>
      </div>
    </header>
   
  );
}

export default HeaderBar;
